// Shared chroma key for the talking-head canvases (green 0,177,64 background).
// Mutates the ImageData in place: green-dominant pixels become transparent, the spill band fades,
// and green-tinted dark edges (curly hair over the green) are despilled and softened.
export function chromaKey(d: Uint8ClampedArray): void {
  for (let i = 0; i < d.length; i += 4) {
    const r = d[i];
    const g = d[i + 1];
    const b = d[i + 2];
    const mx = r > b ? r : b;
    if (g <= mx) continue; // not green-tinted at all: leave untouched (skin, gold, dress, dark hair)
    const m = Math.min(g / (r * 1.45 + 1), g / (b * 1.45 + 1)); // >= 1 means green-dominant
    if (m >= 1 && g > 110) {
      d[i + 3] = 0;
      continue;
    }
    // Any remaining green tint: fade alpha by how green it is relative to its brightness
    // (catches dark green fringes that the bright-key misses), then despill green to the neighbours.
    const tint = (g - mx) / (g + 1); // 0 neutral ... ~1 pure green
    let a = 1;
    if (m > 0.8 && g > 90) a = Math.min(a, (1 - m) / 0.2);
    if (tint > 0.18) a = Math.min(a, 1 - (tint - 0.18) / 0.3);
    if (a < 1) d[i + 3] = Math.round(d[i + 3] * Math.max(0, a));
    d[i + 1] = mx; // despill
  }
}
